import GemMeterBaseRule from '../GemMeterBaseRule';
import { NO_SOURCE_VIDEO } from '../../../constants/rulesConstants';

export default class MissingMediaLinkRule extends GemMeterBaseRule {
  static ruleId = NO_SOURCE_VIDEO.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);

    if (!element) {
      return true;
    }

    const { url } = (element as HTMLElement).dataset;

    return !!(url && url.trim().length > 0);
  }
}
